import {esSetting} from "./config/es";

export const esMoment = (moment: any) => {
    return moment.locale('es', esSetting);
}
